<template>
  <div>
    <!---Title-->
    <div class="title">
      <h1>Registro de envíos</h1>
      <div class="toolbar">
        <!---Message--->
        <span v-if="new Date().getHours() < limitHour" class="text-sm bg-secondary text-white py-2 px-4 rounded">Hora límite para envío de pedidos: {{
          limitHour
          }}:00</span>
        <span v-else-if="new Date().getHours() >= limitHour && new Date().getHours() >= flexHourLimit" class="text-sm bg-gray-900 text-white py-2 px-4 rounded">Tus pedidos serán enviados mañana, revisa la fecha de entrega.</span>
        <span v-else-if="new Date().getHours() >= limitHour && new Date().getHours() < flexHourLimit" class="text-sm bg-gray-900 text-white py-2 px-4 rounded">Tus pedidos serán enviados hoy, con tafira flex.</span>
        <!---End-->
        <button @click="validateList"
                :disabled="total === 0"
                class="btn justify-self-end">
          <span>Registrar envíos S/ ({{ total.toFixed(2) }})</span>
        </button>
      </div>
    </div>
    <!---End-->
    <!---Form-->
    <div class="max-h-0 overflow-hidden transition-all duration-1000"
         :class=" {'showForm': showForm}">
      <div class="grid grid-cols-12 gap-7 md:grid-cols-6">
        <div class="col-span-6 space-y-4 md:col-span-full">
          <div class="grid grid-cols-2 gap-7 md:grid-cols-1 md:gap-4">
            <!--Name-->
            <div class="form-group">
              <label for="fullName">Nombre de cliente*</label>
              <input v-model="document.fullName" class="input" type="text" id="fullName"
                     name="fullName">
              <span v-if="validationErrors.fullName" class="error">{{ validationErrors.fullName }}</span>
            </div>
            <!--End-->
            <!--Phone-->
            <div class="form-group">
              <label for="phone">Celular*</label>
              <input v-model="document.phone" class="input" type="text" id="phone"
                     name="phone">
              <span v-if="validationErrors.phone" class="error">{{ validationErrors.phone }}</span>
            </div>
            <!--End-->
          </div>
          <!--Pickup address--->
          <div class="form-group">
            <label for="district">Local de recojo*</label>
            <select v-model="document.pickupAddress" class="select" name="pickupAddress" id="pickupAddress">
              <option v-for="(a, index) in warehouses" :value="a" :key="index">{{ a }}</option>
            </select>
          </div>
          <!--End-->
          <!--Address-->
          <div class="form-group">
            <label for="address">Dirección de entrega*</label>
            <input v-model="document.address" class="input" type="text" id="address"
                   name="address">
            <span v-if="validationErrors.address" class="error">{{ this.validationErrors.address }}</span>
            <span @click="openGoogleMaps" class="text-sm underline cursor-pointer block mt-2">Ver en mapa</span>
          </div>
          <!--End-->
          <!--Reference-->
          <div class="form-group">
            <label for="address">Referencia</label>
            <input v-model="document.reference" class="input" type="text" id="reference"
                   name="reference">
            <span v-if="validationErrors.reference" class="error">{{ this.validationErrors.reference }}</span>
          </div>
          <!--End-->
          <!--District and location-->
          <div class="grid grid-cols-2 gap-7 md:grid-cols-1 md:gap-4">
            <!--District-->
            <div class="form-group form-group--m0">
              <label for="district">Distrito*</label>
              <select v-model="document.district" class="select" name="district" id="district">
                <option v-for="(e, index) in districts" :value="e" :key="index">{{ e.label }}</option>
              </select>
              <span v-if="validationErrors.district" class="error">{{ validationErrors.district }}</span>
            </div>
            <!--End-->
            <!--Location-->
            <div class="form-group">
              <label for="location">Link de Ubicación (Opcional)</label>
              <input v-model="document.location" class="input" type="text" id="location"
                     name="location">
              <span v-if="validationErrors.location" class="error">{{ validationErrors.location }}</span>
            </div>
            <!--End-->
          </div>
          <!--End-->
          <!--Quantity and product-->
          <div class="grid grid-cols-2 gap-7 md:grid-cols-1 md:gap-4">
            <!--Product-->
            <div class="form-group">
              <label for="product">Producto*</label>
              <input v-model="document.product" class="input" type="text" id="product"
                     name="product">
              <span v-if="validationErrors.product" class="error">{{ validationErrors.product }}</span>
            </div>
            <!--End-->
            <!--Quantity-->
            <div class="form-group">
              <label for="quantity">Cantidad*</label>
              <input v-model.number="document.quantity" class="input" type="number" id="quantity"
                     name="quantity">
              <span v-if="validationErrors.quantity" class="error">{{ validationErrors.quantity }}</span>
            </div>
            <!--End-->
          </div>
          <!--End-->
          <!--Total to be collected and notes-->
          <div class="grid grid-cols-2 gap-7 md:grid-cols-1 md:gap-4">
            <!---Total to be collected-->
            <div class="form-group">
              <label for="totalToBeCollected">Total a cobrar*</label>
              <input v-model.number="document.totalToBeCollected" class="input" type="number" id="totalToBeCollected"
                     name="totalToBeCollected">
              <span v-if="validationErrors.totalToBeCollected" class="error">{{
                this.validationErrors.totalToBeCollected
                }}</span>
            </div>
            <!--End-->
            <!--Notes-->
            <div class="form-group">
              <label for="notes">Notas de entrega</label>
              <input v-model="document.notes" class="input" type="text" id="notes" name="notes">
              <span v-if="validationErrors.notes" class="error">{{ validationErrors.notes }}</span>
            </div>
            <!--End-->
          </div>
          <!--End-->
          <!---Type of service-->
          <div class="flex justify-between gap-7 md:grid-cols-1 md:gap-4">
            <div class="w-full">
              <span
                class="border border-solid border-gray-300 block py-3 px-2 text-center text-sm rounded transition-all duration-300 cursor-pointer mb-2"
                :class=" {
                  'bg-secondary text-white': document.type.value === 'scheduled'
                }">PROGRAMADO</span>
              <a
                class="text-sm block underline"
                href="https://www.google.com/maps/d/u/0/edit?mid=1SaW56KgqvCtVcJgCwES0y1ICgaN4HkQ&usp=sharing"
                target="_blank">Ver mapa de cobertura</a>
            </div>
            <div class="w-full">
              <span
                class="border border-solid border-gray-300 block py-3 px-2 text-center text-sm rounded transition-all duration-300 cursor-pointer mb-2"
                :class=" {
                  'bg-secondary text-white': document.type.value === 'flex'
                }">FLEX</span>
              <a
                class="text-sm block underline"
                href="https://www.google.com/maps/d/u/0/edit?mid=1SaW56KgqvCtVcJgCwES0y1ICgaN4HkQ&usp=sharing"
                target="_blank">Ver mapa de cobertura</a>
            </div>
          </div>
          <!--End-->
        </div>
        <div class="col-span-6 relative">
          <div class="grid grid-cols-2 gap-7 md:grid-cols-1 md:gap-4 mb-4">
            <!--Pickup date-->
            <div class="form-group w-full">
              <label for="deadline">Fecha de recojo*</label>
              <v-date-picker
                expanded
                :min-date="minDate"
                id="pickUpDate"
                name="pickUpDate"
                v-model="document.pickUpDate"
                color="red"
                :timezone="`America/Lima`"
              />
              <span v-if="this.validationErrors.pickUpDate" class="error">{{ this.validationErrors.pickUpDate }}</span>
            </div>
            <!--End-->
            <!--Deadline-->
            <div class="form-group w-full">
              <label for="deadline">Fecha de entrega*</label>
              <v-date-picker
                expanded
                :min-date="minDate"
                id="deadline"
                name="deadline"
                v-model="document.deadline"
                color="red"
                :timezone="`America/Lima`"
              />
              <span v-if="validationErrors.deadline" class="error">{{ validationErrors.deadline }}</span>
            </div>
            <!--End-->
          </div>
          <!--Send-->
          <div class="flex justify-between items-center col-span-2 bg-white p-4 rounded">
            <div>
              <span class="text-sm block mb-2">COSTO DE ENVÍO</span>
              <span class="text-2xl font-semibold block ">S/ {{
                document.district ? document.district.price + document.type?.price : 0
                }}</span>
            </div>
            <button @click="addToList" class="btn justify-self-end">
              <span>Agregar</span>
            </button>
          </div>
          <!--End-->
        </div>
      </div>
    </div>
    <!---End-->
    <hr class="w-full  bg-gray-900 mt-12 mb-6">
    <!--Table toolbar-->
    <table-toolbar
      :district="districts[0]"
      @done="importDone"
      :show-form="showForm"
      @toggleForm="showForm = !showForm"
      @triggerSearch="triggerSearch"></table-toolbar>
    <!--End-->
    <!--Table-->
    <div class="max-w-full overflow-auto">
      <!--Header-->
      <div class="table w-full">
        <div class="table__header">
          <div><span>Fecha de recojo</span></div>
          <div><span>Fecha de entrega</span></div>
          <div><span>Tipo de servicio</span></div>
          <div><span>Local de recojo</span></div>
          <div><span>Dirección</span></div>
          <div><span>Referencia</span></div>
          <div><span>Distrito</span></div>
          <div><span>Nombre de cliente</span></div>
          <div><span>Teléfono</span></div>
          <div><span>Costo de envío</span></div>
          <div><span>Costo Extra</span></div>
          <div><span>Producto</span></div>
          <div><span>Cantidad</span></div>
          <div><span>Total a cobrar</span></div>
          <div><span>Notas de entrega</span></div>
          <div><span>Ubicación</span></div>
          <div><span>Ancho(cm)</span></div>
          <div><span>Alto(cm)</span></div>
          <div><span>Prof.(cm)</span></div>
          <div><span>Peso(kg)</span></div>
          <div><span>Eliminar</span></div>
        </div>
        <div class="table__content">
          <div v-for="(o, index) in filteredList"
               :key="index"
               class="row md:!bg-white"
               :class=" {'row--error': o.error}">
            <div class="row__item">
              <span class="name">FECHA DE RECOJO</span>
              <input v-model="o.pickUpDate" class="input" type="date" id="pickUpDate" name="pickUpDate">
            </div>
            <div class="row__item">
              <span class="name">FECHA DE ENTREGA</span>
              <input v-model="o.deadline" class="input" type="date" id="deadline" name="deadline">
            </div>
            <div class="row__item">
              <span class="name">TIPO DE SERVICIO</span>
              <select v-model="o.type" class="select" name="type" id="type" disabled>
                <option
                  v-for="(e, index) in [ {
                      value: 'scheduled',
                      price: 0,
                      label: 'Programado'
                    }, {
                      value: 'flex',
                      price: 2.10,
                      label: 'Flex'
                    }]"
                  :value="e" :key="index">{{ e.label }}
                </option>
              </select>
            </div>
            <div class="row__item">
              <span class="name">LOCAL DE RECOJO</span>
              <input v-model="o.pickupAddress" class="input" type="text" id="address" name="address">
            </div>
            <div class="row__item">
              <span class="name">DIRECCIÓN</span>
              <input v-model="o.address" class="input" type="text" id="address" name="address">
            </div>
            <div class="row__item">
              <span class="name">REFERENCIA</span>
              <input v-model="o.reference" class="input" type="text" id="reference" name="reference">
            </div>
            <div class="row__item">
              <span class="name">DISTRITO</span>
              <select v-model="o.district" class="select" name="district" id="district">
                <option v-for="(e, index) in districts" :value="e" :key="index">{{ e.label }}</option>
              </select>
            </div>
            <div class="row__item">
              <span class="name">CLIENTE</span>
              <input v-model="o.fullName" class="input" type="text" id="fullName" name="fullName">
            </div>
            <div class="row__item">
              <span class="name">CELULAR</span>
              <input v-model="o.phone" class="input" type="text" id="phone" name="phone">
            </div>
            <div class="row__item">
              <span class="name">COSTO DE ENVÍO</span>
              <input :value="o.district ? o.district.price + o.type?.price : 0" class="input" type="text" disabled
                     id="price"
                     name="price">
            </div>
            <div class="row__item">
              <span class="name">COSTO EXTRA</span>
              <input :value="o.extraCost" class="input" type="text" disabled
                     id="extraCost"
                     name="extraCost">
            </div>
            <div class="row__item">
              <span class="name">PRODUCTO</span>
              <input v-model="o.product" class="input" type="text" id="product" name="product">
            </div>
            <div class="row__item">
              <span class="name">CANTIDAD</span>
              <input v-model="o.quantity" class="input" type="number" id="quantity" name="quantity">
            </div>
            <div class="row__item">
              <span class="name">TOTAL A COBRAR</span>
              <input v-model="o.totalToBeCollected" class="input" type="number" id="totalToBeCollected"
                     name="totalToBeCollected">
            </div>
            <div class="row__item">
              <span class="name">NOTAS DE ENTREGA</span>
              <input v-model="o.notes" class="input" type="text" id="notes"
                     name="notes">
            </div>
            <div class="row__item">
              <span class="name">UBICACIÓN</span>
              <input v-model="o.location" class="input" type="text" id="location"
                     name="location">
            </div>

            <div class="row__item">
              <span class="name">Ancho</span>
              <input v-model="o.width" class="input" type="number" id="quantity" name="quantity">
            </div>

            <div class="row__item">
              <span class="name">Alto</span>
              <input v-model="o.height" class="input" type="number" id="quantity" name="quantity">
            </div>

            <div class="row__item">
              <span class="name">Profundidad</span>
              <input v-model="o.depth" class="input" type="number" id="quantity" name="quantity">
            </div>

            <div class="row__item">
              <span class="name">Peso</span>
              <input v-model="o.weight" class="input" type="number" id="quantity" name="quantity">
            </div>

            <div>
              <span @click="deleteToList(index)">
                <trash-icon class="h-6"></trash-icon>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--End-->
    </div>
    <!---End--->
    <!--Register payment and save in firestore-->
    <pay
      :has-error="hasError"
      :limit-hour="limitHour"
      :flex-limit-hour="flexHourLimit"
      @close="showPaySidebar = false"
      :data="sidebarData"
      :list="list"
      @done="done"
      :class=" {'show': showPaySidebar}"
      :show-navbar="showPaySidebar"></pay>
    <!---End--->
  </div>
</template>

<script>
import * as yup from 'yup'
import TrashIcon from '../components/atoms/icons/TrashIcon.vue'
import TableToolbar from '../components/molecules/TableToolbar.vue'
import moment from 'moment'
import Pay from '../components/organisms/Pay.vue'

import { db } from '@/firebase/firebaseConfig'

yup.setLocale({
  mixed: {
    required: 'Este campo es obligatorio'
  },
  number: {
    positive: 'Debe ser positivo',
    integer: 'Debe ser entero'
  },
  string: {
    email: 'Debe ser  un email'
  }
})

export default {
  name: 'Home',
  components: {
    Pay,
    TableToolbar,
    TrashIcon
  },
  data () {
    return {
      limitHour: 9,
      flexHourLimit: 9,
      document: {
        quantity: 1,
        totalToBeCollected: 0,
        district: null,
        type: {
          value: 'scheduled',
          price: 0,
          label: 'Programado'
        }
      },
      search: '',
      list: [],
      showPaySidebar: false,
      showForm: true,
      sidebarData: {},
      validationErrors: {},
      districts: [],
      schema: {},
      hasError: false,
      client: {},
      content: {},
      // Box dimenssions
      boxDimensions: {
        width: 30,
        height: 25,
        depth: 15,
        weight: 1.5
      },
      warehouses: []
    }
  },
  async created () {
    try {
      this.$store.dispatch('setUser') // Set in store

      this.$store.dispatch('showProgress')
      const storedData = localStorage.getItem('orders')
      if (storedData) {
        this.list = JSON.parse(storedData)
      }

      setInterval(async () => {
        for await (const o of this.list) {
          try {
            o.error = false
            await this.schema.validate({ ...o }, { abortEarly: false })

            const extraCost = this.calculateShipping({
              width: o.width,
              height: o.height,
              depth: o.depth,
              weight: o.weight
            })

            if (extraCost.caseType !== 'Normal') {
              o.extraCost = extraCost.cost
            } else {
              o.extraCost = 0
            }
          } catch (err) {
            o.error = true
          }
        }

        this.hasError = this.list.filter((l) => l.error).length > 0
      }, 1500)
    } catch (e) {
      this.$toast.error('Error al cargar datos', {
        duration: 6000
      })
    } finally {
      this.$store.dispatch('hideProgress')
    }
  },
  computed: {
    total () {
      // eslint-disable-next-line no-return-assign
      return this.list.reduce((acc, o) => {
        return (acc += (o.district ? (o.district.price + o.type?.price + o.extraCost) : 0))
      }, 0)
    },
    filteredList () {
      return this.list.filter(o => {
        return o.fullName.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    user () {
      return this.$store.state.user
    },
    minDate () {
      return (new Date().getHours() < this.limitHour || new Date().getHours() < this.flexHourLimit) ? new Date() : new Date(new Date().setDate(new Date().getDate() + 1))
    }
  },
  watch: {
    list: {
      handler (val) {
        // Save to local storage
        // window.localStorage.setItem('orders', JSON.stringify(this.list))
        // End
      },
      deep: true
    },
    async user (val) {
      if (val) {
        try {
          await this.getDistricts()
          await this.getClient()
          await this.getContent()
          await this.createValidations()
          await this.getWarehouses()
        } catch (e) {
          this.$toast.error('Error al cargar usuario', {
            duration: 6000
          })
        }
      }
    }
  },
  methods: {
    /**
     * Add to list
     * @returns {Promise<void>}
     */
    async addToList () {
      try {
        this.search = ''
        this.validationErrors = {}
        await this.schema.validate({ ...this.document }, { abortEarly: false })
        // Add
        this.document.pickUpDate = moment(this.document.pickUpDate).format('YYYY-MM-DD')
        this.document.deadline = moment(this.document.deadline).format('YYYY-MM-DD')
        this.document.width = this.boxDimensions.width
        this.document.height = this.boxDimensions.height
        this.document.depth = this.boxDimensions.depth
        this.document.weight = this.boxDimensions.weight
        this.document.extraCost = 0

        this.list.unshift({
          ...this.document,
          error: false
        })
        // Save to local storage
        // window.localStorage.setItem('orders', JSON.stringify(this.list))
        // End

        this.reset()
        // End
      } catch (err) {
        if (err.inner) {
          err.inner.forEach(error => {
            if (error.path) {
              this.validationErrors[error.path] = error.message
            }
          })
        } else {
          this.$toast.error('Error al agregar', {
            duration: 6000
          })
        }
      }
    },
    /**
     * Delete to list
     * @param index
     */
    deleteToList (index) {
      this.list.splice(index, 1)
      // Save to local storage
      // window.localStorage.setItem('orders', JSON.stringify(this.list))
      // End
    },
    /**
     * Open google maps
     */
    openGoogleMaps () {
      const encodedAddress = encodeURIComponent(this.document.address)
      const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${
encodedAddress
}`
      window.open(googleMapsUrl, '_blank')
    },
    /**
     * Pre validate shipments
     * @returns {Promise<boolean>}
     */
    async validateList () {
      if (this.total > 0) {
        this.$store.dispatch('showProgress')
        let allItemsValid = true
        for await (const o of this.list) {
          try {
            o.error = false
            await this.schema.validate({ ...o }, { abortEarly: false })
          } catch (err) {
            allItemsValid = false
            o.error = true
            err.inner.forEach(error => {
              if (error.params?.label) {
                this.$toast.error('Error en ' + error.params?.label, {
                  duration: 5000
                })
              }
            })
          }
        }
        this.$store.dispatch('hideProgress')
        if (allItemsValid) {
          this.sidebarData = {
            total: this.total,
            client: this.client,
            content: this.content
          }
          this.showPaySidebar = true
        }
      }
    },
    /**
     * Reset form
     */
    reset () {
      this.document = {
        quantity: 1,
        totalToBeCollected: 0,
        district: this.districts[0] || null,
        type: {
          value: 'scheduled',
          price: 0,
          label: 'Programado'
        },
        pickUpDate: new Date().getHours() < this.limitHour ? new Date() : new Date(new Date().setDate(new Date().getDate() + 1)),
        deadline: new Date().getHours() < this.limitHour ? new Date() : new Date(new Date().setDate(new Date().getDate() + 1)),
        pickupAddress: this.document.pickupAddress = this.warehouses[0]
      }

      this.document.pickUpDate = (new Date().getHours() < this.limitHour || new Date().getHours() < this.flexHourLimit) ? new Date() : new Date(new Date().setDate(new Date().getDate() + 1))
      this.document.deadline = (new Date().getHours() < this.limitHour || new Date().getHours() < this.flexHourLimit) ? new Date() : new Date(new Date().setDate(new Date().getDate() + 1))

      if (new Date().getHours() >= this.limitHour && new Date().getHours() < this.flexHourLimit) {
        this.document.type = {
          value: 'flex',
          price: 2.10,
          label: 'Flex'
        }
      }
    },
    /**
     * Done
     */
    done () {
      this.reset()
      this.list = []
      this.showPaySidebar = false
      this.$toast.success('Envíos guardados correctamente', {
        duration: 6000
      })
    },
    /**
     * Trigger search
     */
    triggerSearch (value) {
      this.search = value
    },
    /**
     * Get districts from Firebase
     */
    async getDistricts () {
      const snap = await db.collection('districts').orderBy('sortOrder', 'asc').get()
      this.districts = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
      if (!this.document.district && this.districts.length) {
        this.document.district = this.districts[0]
      }
    },
    /**
     * Get content
     */
    async getContent () {
      const contentDoc = await db.collection('content').doc('XlAI9aWADYktW6JmkttO').get()
      if (contentDoc.exists) {
        this.content = {
          id: contentDoc.id,
          ...contentDoc.data()
        }
      }
    },
    /**
     * Get client
     * @returns {Promise<void>}
     */
    async getClient () {
      const clientDoc = await db.collection('clients').doc(this.user.client.id).get()
      this.client = {
        id: clientDoc.id,
        name: clientDoc.data().businessName,
        hourLimit: clientDoc.data().hourLimit,
        flexHourLimit: clientDoc.data().flexHourLimit,
        document: clientDoc.data().document,
        paymentMethod: clientDoc.data().paymentMethod
      }
      this.limitHour = this.client.hourLimit
      this.flexHourLimit = this.client.flexHourLimit

      this.document.pickUpDate = (new Date().getHours() < this.limitHour || new Date().getHours() < this.flexHourLimit) ? new Date() : new Date(new Date().setDate(new Date().getDate() + 1))
      this.document.deadline = (new Date().getHours() < this.limitHour || new Date().getHours() < this.flexHourLimit) ? new Date() : new Date(new Date().setDate(new Date().getDate() + 1))

      if (new Date().getHours() >= this.limitHour && new Date().getHours() < this.flexHourLimit) {
        this.document.type = {
          value: 'flex',
          price: 2.10,
          label: 'Flex'
        }
      }
    },
    /**
     * Import done
     */
    importDone (results) {
      results.forEach((r) => {
        if (r['Nombre de cliente']) {
          this.list.push({
            pickUpDate: (this.limitHour > new Date().getHours() && this.flexHourLimit > new Date().getHours()) ? moment(new Date()).format('YYYY-MM-DD') : moment(new Date().setDate(new Date().getDate() + 1)).format('YYYY-MM-DD'),
            deadline: (this.limitHour > new Date().getHours() && this.flexHourLimit > new Date().getHours()) ? moment(new Date()).format('YYYY-MM-DD') : moment(new Date().setDate(new Date().getDate() + 1)).format('YYYY-MM-DD'),
            type: (new Date().getHours() >= 6 && new Date().getHours() < this.limitHour) ? {
              value: 'flex',
              price: 2.10,
              label: 'Flex'
            } : {
              value: 'scheduled',
              price: 0,
              label: 'Programado'
            },
            pickupAddress: r['Local de recojo (Direccion de recojo)']?.trim(),
            address: r['Dirección (Direccion de entrega)']?.trim(),
            reference: r.Referencia?.trim(),
            district: this.districts.find((d) =>
              d.label &&
              d.label.toLowerCase().trim() === (r.Distrito?.toLowerCase().trim() || '')
            ) || null,
            fullName: r['Nombre de cliente']?.trim(),
            phone: r['Teléfono'] ? r['Teléfono'] : '',
            product: r.Producto?.trim(),
            quantity: r.Cantidad,
            totalToBeCollected: r['Total a cobrar'],
            notes: r['Notas de entrega']?.trim(),
            location: r['Ubicación']?.trim(),
            width: this.boxDimensions.width,
            height: this.boxDimensions.height,
            depth: this.boxDimensions.depth,
            weight: this.boxDimensions.weight,
            extraCost: 0
          })
        }
      })
      this.validateList()
    },

    /**
     * Create validations
     */
    createValidations () {
      // Get the current date and time
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())

      // Create yup schema
      this.schema = yup.object().shape({
        fullName: yup.string().required().label('Nombre completo'),
        phone: yup.string().required().label('Celular'),
        address: yup.string().required().label('Dirección'),
        pickupAddress: yup.string().min(10, 'dirección inválida').required().label('Local de recojo (Formato incorrecto)'),
        reference: yup.string().label('Referencia'),
        district: yup.object().shape({ label: yup.string().required() }).required().label('Distrito'),
        location: yup.string().label('Ubicación'),
        product: yup.string().required().label('Producto'),
        notes: yup.string().label('Notas'),
        quantity: yup.number().required().positive().integer().label('Cantidad'),
        totalToBeCollected: yup.number().label('Total a recolectar'),
        pickUpDate: yup.date()
          .required()
          .test('is-valid-date', 'Fecha inválida', (value) => {
            const currentDate = new Date()
            const selectedDate = new Date(value)

            // Set the cutoff time for today at the exact desired hour
            const todayAtLimitHour = new Date(today)
            todayAtLimitHour.setHours(this.flexHourLimit, 0, 0, 0)

            if (currentDate < todayAtLimitHour) {
              return selectedDate >= today
            } else {
              const tomorrow = new Date(today)
              tomorrow.setDate(tomorrow.getDate() + 1)
              return selectedDate >= tomorrow
            }
          }).label('Fecha de recojo'),
        deadline: yup.date()
          .required()
          .test('is-valid-date', 'Fecha inválida', (value) => {
            const currentDate = new Date()
            const selectedDate = new Date(value)

            // Set the cutoff time for today at the exact desired hour
            const todayAtLimitHour = new Date(today)
            todayAtLimitHour.setHours(this.flexHourLimit, 0, 0, 0)

            // If the current time is before 8 PM, allow today or future dates
            if (currentDate < todayAtLimitHour) {
              return selectedDate >= today
            } else {
              // If the current time is after 8 PM, allow only future dates
              const tomorrow = new Date(today)
              tomorrow.setDate(tomorrow.getDate() + 1)
              return selectedDate >= tomorrow
            }
          }).label('Fecha de entrega')
      })
      // End
    },
    calculateShipping ({ width, height, depth, weight }) {
      // Normalizar entradas
      width = Number(width) || 0
      height = Number(height) || 0
      depth = Number(depth) || 0
      weight = Number(weight) || 0

      // Límites
      const maxDimensions = { width: 30, height: 25, depth: 15 } // cm
      const maxWeight = 1.5 // kg
      const divisor = 6000 // divisor volumétrico
      const costPerKg = 1.5 // PEN por kg

      // Calcular peso volumétrico
      const volumetricWeight = (width * height * depth) / divisor

      // Excesos
      const exceedsDimensions =
        width > maxDimensions.width ||
        height > maxDimensions.height ||
        depth > maxDimensions.depth

      const exceedsWeight = weight > maxWeight

      let chargeableWeight = 0
      let caseType = 'Normal'

      if (exceedsDimensions && !exceedsWeight) {
        // Solo excede dimensiones → cobrar exceso volumétrico
        chargeableWeight = volumetricWeight - maxWeight
        caseType = 'Excess volume'
      } else if (!exceedsDimensions && exceedsWeight) {
        // Solo excede peso → cobrar exceso de peso
        chargeableWeight = weight - maxWeight
        caseType = 'Overweight'
      } else if (exceedsDimensions && exceedsWeight) {
        // Exceden ambos → cobrar el mayor exceso
        chargeableWeight = Math.max(weight, volumetricWeight) - maxWeight
        caseType = 'Volume + Overweight'
      }

      // Costo (solo excedente)
      const cost = chargeableWeight > 0 ? chargeableWeight * costPerKg : 0

      return {
        caseType,
        volumetricWeight: Number(volumetricWeight.toFixed(2)),
        chargeableWeight: Number(chargeableWeight.toFixed(2)),
        cost: Number(cost.toFixed(2))
      }
    },
    /**
     * Get warehouses
     */
    async getWarehouses () {
      const querySnap = await db.collection('clients').doc(this.client.id).collection('addresses').where('state', '==', true).get()
      querySnap.forEach((doc) => {
        this.warehouses.push(doc.data().address)
      })

      this.document.pickupAddress = this.warehouses[0]
    }
  }
}
</script>

<style>
.showForm {
  max-height: 2000px !important;
}
</style>
